<script setup lang="ts">
/*Vue*/
import { reactive, watch } from "vue";

import * as service from "@/services/relatoriosService";
import { fdata } from "@/utils/funcoes";

/*Componentes*/
import Cabecalho from "@/components/ReportView/Cabecalho.vue";

interface IProps {
  clientes?: service.RelClienteDTO[],
  filtros?: string
}

const props = defineProps<IProps>();

interface IItem {
  cpf: string,
  nome: string,
  dataNascimento?: Date,

  clienteId?: number,
  tipo?: string,
  nomeCliente?: string,
  erro: ''
}

let controle = reactive({
  clientes: [] as service.RelClienteDTO[],
  itens: [] as IItem[],
  status: "",
  erro: ""
});

watch(() => props.clientes, async (newValue) => {
  controle.clientes = newValue ?? [];
  await processar();
  await processarDependentes();
}, { immediate: true });

async function processar() {

  try {

    controle.itens = [] as IItem[];

    controle.clientes.forEach(e => {

      var jaTem = null;

      if (e.cpf != null && e.cpf != undefined) {
        e.cpf = e.cpf?.replace(/\D/g, ""); // Remove caracteres não numéricos do CPF
      }

      if (e.cpf != null && e.cpf != undefined && e.cpf != "") {
        jaTem = controle.itens.find(a => a.cpf == e.cpf);

        if (jaTem != null) {
          console.log("ja tem: " + e.nome + " " + e.cpf);
          return;
        }
      }
      else {
        console.log("Sem cpf: " + e.nome + " " + e.cpf);
      }

      var item = {
        cpf: e.cpf,
        nome: e.nome,
        dataNascimento: e.dataNascimento,

        clienteId: e.clienteId,
        tipo: "Titular",
        erro: ''
      } as unknown as IItem;

      controle.itens.push(item);
    });

  } catch (error) {
    controle.erro = "erro agrupando";
  }
}


async function processarDependentes() {

  try {

    controle.clientes.filter(a => a.dependentes.length > 0).forEach(cliente => {

      cliente.dependentes.forEach(dependente => {

        var jaTem = null;

        if (dependente.cpf != null && dependente.cpf != undefined) {
          dependente.cpf = dependente.cpf?.replace(/\D/g, ""); // Remove caracteres não numéricos do CPF
        }

        if (dependente.cpf != null && dependente.cpf != undefined && dependente.cpf != "") {
          jaTem = controle.itens.find(a => a.cpf == dependente.cpf);

          if (jaTem != null) {
            console.log("ja tem: " + dependente.nome + " " + dependente.cpf);
            return;
          }
        }
        else {
          console.log("Sem cpf: " + dependente.nome + " " + dependente.cpf);
        }

        var item = {
          cpf: dependente.cpf,
          nome: dependente.nome,
          dataNascimento: dependente.dataNascimento,

          clienteId: cliente.clienteId,
          nomeCliente: cliente.nome,
          tipo: dependente.parentesco,
          erro: (!dependente.cpf ? "Sem CPF" : "")
        } as unknown as IItem;

        controle.itens.push(item);
      });
    });

  } catch (error) {
    controle.erro = "erro agrupando";
  }
}

function titulo(item: IItem) {
  if (item.tipo == "Titular") {
    return "Titular";
  }
  else {
    return item.tipo + " de " + item.nomeCliente + " (Cliente: " + item.clienteId + ")";
  }
}

</script>

<template>
  <Cabecalho :Titulo="'Relatório de Clientes - Assistência Funeral'" :Filtros="props.filtros" />

  <div>{{ controle.itens.filter(a=> a.cpf).length }} Registros</div>
  <table class="table table-sm table-hover table-striped table-bordered">
    <thead class="">
      <tr>
        <th class="text-nowrap">Nome</th>
        <th class="text-center">Data Nascimento</th>
        <th class="text-center">CPF</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(cliente, idx) in controle.itens.filter(a=> a.cpf)" :key="idx" :class="!cliente.cpf ? 'table-warning' : ''">
        <td class="text-start" data-label="Nome" :title="titulo(cliente)"> {{ cliente.nome }} </td>
        <td class="text-center" data-label="Data Nascimento"> {{ fdata(cliente.dataNascimento) }} </td>
        <td class="text-center" data-label="CPF"> {{ cliente.cpf }} </td>
      </tr>
    </tbody>
  </table>

  <template v-if="controle.itens.filter(a => a.erro != '').length > 0">
    <div style="margin-top: 1rem;" class="margin-t">{{controle.itens.filter(a => a.erro != '').length}} Erros</div>
    <table class="table table-sm table-hover table-striped table-bordered"
      v-if="controle.itens.filter(a => a.erro != '').length > 0">
      <thead class="">
        <tr>
          <th class="text-start">Cliente</th>
          <th class="text-start">Nome</th>
          <th class="text-start">Dependente</th>
          <th class="text-start">Parentesco</th>
          <th class="text-start">Erro</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(cliente, idx) in controle.itens.filter(a => a.erro != '')" :key="idx"
          :class="!cliente.cpf ? 'table-warning' : ''">
          <td class="text-start" data-label="Cliente" > {{ cliente.clienteId }} </td>
          <td class="text-start" data-label="Nome"> {{ cliente.nomeCliente }} </td>
          <td class="text-start" data-label="Dependente"> {{ cliente.nome }} </td>
          <td class="text-start" data-label="Parentesco"> {{ cliente.tipo }} </td>
          <td class="text-start text-nowrap" data-label="Erro"> {{ cliente.erro }} </td>
        </tr>
      </tbody>
    </table>
  </template>

</template>


<style scoped>
  .table > :not(caption) > * > * {
    padding: 5px 5px;
  }
</style>
